import { render, staticRenderFns } from "./AsiFormErrors.vue?vue&type=template&id=5087cffc&scoped=true&"
import script from "./AsiFormErrors.vue?vue&type=script&lang=ts&"
export * from "./AsiFormErrors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5087cffc",
  null
  
)

export default component.exports